export const getAPIResponse = (state) => state.APIResponseDetails;
